/**
 * Design System - Theme
 * نظام التصميم الموحد للتطبيق
 */

export const lightTheme = {
  // Colors
  primary: '#007bff',
  primaryDark: '#0056b3',
  primaryLight: '#66b3ff',
  secondary: '#6c757d',
  success: '#28a745',
  danger: '#dc3545',
  warning: '#ffc107',
  info: '#17a2b8',
  
  // Backgrounds
  background: '#ffffff',
  surface: '#f8f9fa',
  surfaceElevated: '#ffffff',
  border: '#dee2e6',
  
  // Text
  text: '#212529',
  textSecondary: '#6c757d',
  textMuted: '#adb5bd',
  
  // Shadows
  shadow: '0 2px 4px rgba(0,0,0,0.1)',
  shadowMedium: '0 4px 8px rgba(0,0,0,0.15)',
  shadowLarge: '0 8px 16px rgba(0,0,0,0.2)',
  
  // Spacing
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px'
  },
  
  // Border Radius
  radius: {
    sm: '4px',
    md: '8px',
    lg: '12px',
    xl: '16px',
    full: '9999px'
  },
  
  // Typography
  fontFamily: {
    sans: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    mono: 'Monaco, "Courier New", monospace'
  },
  
  fontSize: {
    xs: '12px',
    sm: '14px',
    base: '16px',
    lg: '18px',
    xl: '20px',
    '2xl': '24px',
    '3xl': '30px'
  }
};

export const darkTheme = {
  // Colors
  primary: '#0d6efd',
  primaryDark: '#0a58ca',
  primaryLight: '#3d8bfd',
  secondary: '#6c757d',
  success: '#198754',
  danger: '#dc3545',
  warning: '#ffc107',
  info: '#0dcaf0',
  
  // Backgrounds
  background: '#1a1a1a',
  surface: '#2d2d2d',
  surfaceElevated: '#3a3a3a',
  border: '#404040',
  
  // Text
  text: '#ffffff',
  textSecondary: '#b0b0b0',
  textMuted: '#808080',
  
  // Shadows
  shadow: '0 2px 4px rgba(0,0,0,0.3)',
  shadowMedium: '0 4px 8px rgba(0,0,0,0.4)',
  shadowLarge: '0 8px 16px rgba(0,0,0,0.5)',
  
  // Spacing (same as light)
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px'
  },
  
  // Border Radius (same as light)
  radius: {
    sm: '4px',
    md: '8px',
    lg: '12px',
    xl: '16px',
    full: '9999px'
  },
  
  // Typography (same as light)
  fontFamily: {
    sans: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    mono: 'Monaco, "Courier New", monospace'
  },
  
  fontSize: {
    xs: '12px',
    sm: '14px',
    base: '16px',
    lg: '18px',
    xl: '20px',
    '2xl': '24px',
    '3xl': '30px'
  }
};

